import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';

import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import {colors, fontSizes, fonts, layout, spacings} from 'style';
import defaultAvatar from 'img/default-avatar.png';
import moment from 'moment';

const style = {
    content: {
        padding: '1px',
        position:'relative',
        textAlign: 'center',
        ...fonts.body,
        lineHeight: '1.5',
        padding: spacings.base,
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
    },
    segment: {
        width: '100%',
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: '80px',
        border: 'none',
        boxShadow: 'none',
    },
    bannerWrapper: {
        position: 'absolute',
        top: '-45px',
        left: '50%',
        marginLeft: '-35px',
        borderRadius: '50%',
        height: '70px',
        width: '70px',
    },
    bannerImg: {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '70px',
        width: '70px',
        verticalAlign: 'top',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundRepeat: 'no-repeat',
    },
    leaderboardInfo: {
        position: 'relative',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        borderRadius: '20px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderWidth: '3px',
        boxShadow: '0px 3px 2px rgba(0,0,0,0.2)',
        padding: '30px 0px 10px 0px',
        marginBottom: '15px',
    },
    title: {
        fontSize: '1.2em',
        paddingBottom: '10px',
    },
    subTitle: {
    },
    recordInfo: {
        marginTop: '20px',
        marginBottom: '20px',
        paddingTop: '20px',
        paddingBottom: '20px',
        fontSize: '1.5em',
    },
    message: {
        opacity: '0.9',
        margin: '40px 0px 40px 0px',
    },
    total: {
        marginRight: '10px',
        marginLeft: '10px',
        color: colors.themeLightBlue, 
        display: 'inline-block',
    },
    rank: {
        marginRight: '10px',
        marginLeft: '10px',
        color: colors.pointsYellow, 
        display: 'inline-block',
    },
    disbandButton: {
        margin: '20px 0px 0px 0px',
        width: '50%',
        border: 'none',
        borderRadius: '0',
        backgroundColor: 'transparent',
        color: colors.themeMaroon,
        fontSize: '1.1em',
    },
    member: {
        display: 'inline-block',
        margin: '20px 20px 20px 20px',
    },
    labelImage: {
        width: '55px',
        height: '55px',
        display: 'inline-block', 
        borderRadius: '50%', 
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundColor:colors.themeBlue,
        margin: '0px 0px 0px 0px',
        opacity: '1',
    },
    userName: {
        opacity: '0.7',
        fontSize: '0.9em',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    userChallenge: {
        fontSize: '1.5em',
        color: colors.themeBlue,
    },
    continueButton: {
        color: '#fff',
        backgroundColor: colors.themeTeal,
        borderRadius: '36px',
        marginBottom: '40px',
        paddingLeft: '40px',
        paddingRight: '40px',
        fontWeight: 'normal',
        width: '320px',
    },

};

const getUserName = (userProfile) => {
    if(!userProfile.firstName && !userProfile.lastName) {
        return userProfile.email;
    }
    return Utils.titleCase(userProfile.firstName + ' ' + Utils.limitTo(userProfile.lastName,1))
}


const TeamChallenge = ({t,
                        busy, 
                        record, 
                        onClickDisband, 
                        onClickLeaderboardIcon, 
                        onContinue,
                        myTeam,
                        completeScreen}) => (
    <div style={style.content}>
        {busy && 
            <LoadInline centered vcentered /> 
        }
        {!busy &&
            <div style={style.segment}>
                {record &&
                    <div>
                        {record.leaderboard &&
                            <div style={style.leaderboardInfo}>
                                {record.leaderboard.banner &&
                                <div style={style.bannerWrapper}>
                                    <div style={{...style.bannerImg, backgroundImage:Utils.url(record.leaderboard.banner.url)}}></div>
                                </div>
                                }
                                <div style={style.title}>{record.leaderboard.title}</div>
                                <div style={style.subTitle}>{record.completed ? t('Challenge Completed') : t('Waiting for Team')}</div>
                            </div>
                        }

                        {record.challengeRecordMembers &&
                            <div style={style.members}>
                                {record.challengeRecordMembers.map(member=>(
                                    <div key={member.userProfileId} style={style.member}>
                                        <div style={{...style.labelImage, backgroundImage:'url('+((member.userProfile.avatar!=null) ? member.userProfile.avatar.url : defaultAvatar)+')'}}></div>
                                        <div style={style.userName}>{getUserName(member.userProfile)}</div>
                                        <div style={style.userChallenge}>{member.userChallenge ? member.userChallenge.value : '?'}</div>
                                    </div>
                                ))}
                            </div>
                        }

                        {record.completed ? (
                            <div style={style.recordInfo}>
                                <div style={style.total}>{t('Total_{{val}}', {val:record.value})}</div>
                                <div style={style.rank}>{t('Rank_{{val}}', {val:record.rank})}</div>
                            </div>
                        ) : (
                            <div style={style.message}>{t('Invitations have been sent to your team members')}</div>
                        )}
                                
                        {Boolean(myTeam && !completeScreen) &&
                            <Button style={{...style.disbandButton}} onClick={onClickDisband}>{t('Disband Team')}</Button>
                        }
                        {Boolean(completeScreen) &&
                            <Button style={style.continueButton} onClick={onContinue}>{t('CONTINUE')}</Button>
                        }
                    </div>
                }
            </div>
        }
    </div>
);

export default translate('teamchallenges')(TeamChallenge);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/TeamChallenge.js